import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-redirect {
  display: flex;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #425048;
  background: #f3f7f4;
}

.auth-redirect__card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  border: 1px solid #dce5df;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(11, 47, 34, 0.1);
}

.auth-redirect__logo {
  width: auto;
  height: 30px;
}

.auth-redirect__spinner {
  width: 18px;
  height: 18px;
  border: 2px solid #d9e9de;
  border-top-color: #248b4b;
  border-radius: 999px;
  animation: redirectSpin 700ms linear infinite;
}

.auth-redirect p {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}

@keyframes redirectSpin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .auth-redirect__spinner {
    animation: none;
  }
}`],
})
export class PageSignupComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        window.location.replace('/access?mode=signup');
    }
}

export default PageSignupComponent;